var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TagsEditor',{attrs:{"new-tag-label":"Add sector","value":_vm.tagsValue,"options":_vm.sectorOptions,"allow-to-add-tags":_vm.canAddSector},on:{"change":_vm.onTagsChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var tag = ref.tag;
return [_vm._v("\n      "+_vm._s(_vm._f("sectorLabel")(tag))+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }